import { createFileRoute } from "@tanstack/react-router";
import { RoofingServicePage } from "@/components/RoofingServicePage";
import { solarServicePages } from "@/data/solarServiceContent";

export const Route = createFileRoute("/services/ev-charger-installation")({
  head: () => ({
    meta: [
      { title: "EV Charger Installation in Southern California – McKay Roofing & Solar" },
      { name: "description", content: "Level 2 home and business EV charger installations across Southern California. Bundle with solar or a battery for lower charging costs." },
      { property: "og:title", content: "EV Charger Installation – McKay Roofing & Solar" },
      { property: "og:description", content: "Level 2 EV charger installs across Southern California, often bundled with solar." },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/services/ev-charger-installation" }],
  }),
  component: () => <RoofingServicePage {...solarServicePages["ev-charger-installation"]} />,
});